import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Wraps an existing section so its content is collapsed by default with a
 * "Show More" toggle. Used on dense Home page sections to streamline scroll.
 */
const CollapsibleSection = ({
  children,
  previewHeight = 80,
  label = 'Show More',
  testId = 'collapsible-section',
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div data-testid={testId} className="relative">
      <div
        className={`relative overflow-hidden transition-[max-height] duration-500 ease-out ${
          expanded ? 'max-h-[5000px]' : ''
        }`}
        style={!expanded ? { maxHeight: previewHeight } : undefined}
      >
        {children}
        {!expanded && (
          <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black via-black/90 to-transparent pointer-events-none" />
        )}
      </div>
      <div className="text-center -mt-6 relative z-10">
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          data-testid={`${testId}-toggle`}
          className="inline-flex items-center gap-2 bg-zinc-900/90 backdrop-blur-md border border-red-900/40 hover:border-red-500/70 text-gray-300 hover:text-white text-xs font-black tracking-[0.2em] uppercase px-5 py-2.5 rounded-full transition-colors"
        >
          {expanded ? 'Show Less' : label}
          <ChevronDown
            className={`h-3.5 w-3.5 transition-transform ${expanded ? 'rotate-180' : ''}`}
          />
        </button>
      </div>
    </div>
  );
};

export default CollapsibleSection;
